import type { HasId, WithName } from '@types';

export function checkIdProperty(obj: unknown): obj is HasId {
  return typeof obj === 'object' && obj !== null && 'id' in obj;
}

export function checkNameProperty(obj: unknown): obj is WithName {
  return typeof obj === 'object' && obj !== null && 'name' in obj;
}
